import React, { useEffect, useState } from 'react'
import { cloneDeep } from 'lodash'

import Select from 'components/common/Select'
import Input from 'components/common/Input'
import DatePicker from 'components/common/DatePicker'
import DataTypeIcon from 'components/common/DataTypeIcon'
import IconHeaderFlag from 'components/common/IconHeaderFlag'

import Box from 'components_new/atoms/Box'
import Divider from 'components_new/atoms/Divider'
import Icon from 'components_new/atoms/Icon'
import Tooltip from 'components_new/atoms/Tooltip'

import ToggleButton from 'components_new/molecules/ToggleButton'

import Filters from './Filters'

import { getSelectOptions, isDate, InfoMessage } from './conf'

import { OPERATION_TYPES } from '../conf'

import Styles from './styles.module.css'

const ReplaceOperation = ({
  chosenAttributes,
  filterData,
  setFilterData,
  type
}) => {
  const [newColumn, setNewColumn] = useState(true)
  const [valueToggle, setValueToggle] = useState(false)

  const [stateChosenAttributes, setStateChosenAttributes] = useState(
    cloneDeep(chosenAttributes)
  )
  const newAttributeName = filterData.newAttribute

  useEffect(() => {
    if (newAttributeName in stateChosenAttributes) {
      const copyState = cloneDeep(stateChosenAttributes)

      delete copyState[newAttributeName]
      setStateChosenAttributes(copyState)
    }
  }, [stateChosenAttributes])

  useEffect(() => {
    setNewColumn(filterData.newAttribute ? true : false)
    setValueToggle(filterData.rightAttribute ? false : true)
  }, [])

  const dataType = chosenAttributes[filterData.leftAttribute]?.type

  return (
    <>
      <IconHeaderFlag
        icon={OPERATION_TYPES[type].icon}
        header={OPERATION_TYPES[type].label}
      />
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 2 }}>
        <Select
          label={'Kolumn'}
          options={getSelectOptions(stateChosenAttributes)}
          value={filterData.leftAttribute}
          onChange={(ev) => {
            setFilterData({
              ...filterData,
              leftAttribute: ev
            })
          }}
        />
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 2 }}>
        <InfoMessage
          infoText={`Bestäm om värdet i kolumnen ska ersättas av
              ett nytt värde, eller om det ska ersättas av ett värde från en
              annan kolumn i datasetet.`}
        />
        <ToggleButton
          items={[
            { title: 'Värde', value: true },
            { title: 'Kolumn', value: false }
          ]}
          onChange={(event, value) => {
            setValueToggle(value)
            if (value) {
              // Goes from column -> value
              setFilterData({
                ...filterData,
                rightAttribute: null
              })
            } else {
              // Goes from value -> column
              setFilterData({
                ...filterData,
                value: null
              })
            }
          }}
          size="small"
          value={valueToggle}
        />
        {valueToggle ? (
          <ReplaceValueFormItem
            dataType={dataType}
            filterData={filterData}
            setFilterData={setFilterData}
          />
        ) : (
          <Select
            size="middle"
            placeholder={'Kolumn'}
            options={getSelectOptions(stateChosenAttributes, dataType)}
            value={filterData.rightAttribute}
            onChange={(value) => {
              setFilterData({
                ...filterData,
                rightAttribute: value
              })
            }}
          />
        )}
        <ToggleButton
          items={[
            { title: 'Samma kolumn', value: false },
            { title: 'Ny kolumn', value: true }
          ]}
          onChange={(event, value) => setNewColumn(value)}
          size="small"
          value={newColumn}
        />
        {newColumn ? (
          <Input
            prefix={
              <DataTypeIcon
                type={stateChosenAttributes[filterData.leftAttribute]?.type}
              />
            }
            suffix={
              // eslint-disable-next-line max-len
              <Tooltip title="Resultatet av din ersättning kommer att lagras i en ny kolumn. Döp denna kolumn till ett lämpligt namn.">
                <Icon name="HelpOutline" fontSize="small" />
              </Tooltip>
            }
            label={'Kolumn'}
            value={filterData.newAttribute}
            onChange={(v) => {
              setFilterData({
                ...filterData,
                newAttribute: v
              })
            }}
          />
        ) : null}
      </Box>
      <Divider sx={{ my: 2 }} />
      <Filters
        chosenAttributes={stateChosenAttributes}
        filterData={filterData}
        setFilterData={setFilterData}
      />
    </>
  )
}

const ReplaceValueFormItem = ({ dataType, filterData, setFilterData }) => {
  console.log(dataType)
  let inputField = (
    <Input
      size={'middle'}
      placeholder={'Värde'}
      value={filterData.value}
      onChange={(v) => {
        setFilterData({ ...filterData, value: v })
      }}
    />
  )

  if (isDate(dataType)) {
    inputField = (
      <DatePicker
        size={'middle'}
        className={Styles['filter-operation-date-picker']}
        value={filterData.value}
        onChange={(value) => {
          setFilterData({
            ...filterData,
            value: value
          })
        }}
      />
    )
  }

  return inputField
}

export default ReplaceOperation
